import React from "react";

import { s360ConfigService } from "../Services/S360Config";

function DefaultFooter(props) {
  const isFullScreen = localStorage.getItem("openInFullScreen");
  const isInAgentHistoryPage = props?.isInAgentHistoryPage;
  const showFooter = s360ConfigService?.config?.showFooter;
  return (
    <div
      className={`s360-conversation-page-footer-brand-container${isFullScreen ? "-fs" : ""}`}
      style={{ position: isInAgentHistoryPage ? "absolute" : "sticky",display: showFooter ? "flex" : "none" }}
    >
      <span>Powered By</span>
      <img
        alt=""
        style={{ marginLeft: "2%" }}
        height="20px"
        src="https://nextiva.simplify360.com/whitelabel/14/images/logo.svg"
      />
    </div>
  );
}

export default DefaultFooter;

